// extracted by mini-css-extract-plugin
var _1 = "PageOnboarding-module__animatedScene--kcOsl";
var _2 = "PageOnboarding-module__backgroundImage--JtTFo";
var _3 = "PageOnboarding-module__dialogTitle--jjA8l CoreGeneral__robotoSlab--X8lgW";
var _4 = "PageOnboarding-module__hiddenDialog--PjUcl";
var _5 = "PageOnboarding-module__logo--hn_Gm";
var _6 = "PageOnboarding-module__onboarding--x8THo";
var _7 = "PageOnboarding-module__sceneDialogWrapper--hDkzh";
export { _1 as "animatedScene", _2 as "backgroundImage", _3 as "dialogTitle", _4 as "hiddenDialog", _5 as "logo", _6 as "onboarding", _7 as "sceneDialogWrapper" }
